import { UserResponse } from '../../../api/models/user-response';
import { DEMO_CUSTOMER_PROFILE_ID } from '../demo-jwt';

const NOW_ISO = new Date().toISOString();
const JOINED_ISO = new Date(Date.now() - 220 * 24 * 60 * 60 * 1000).toISOString();

/** The demo admin user, returned from /auth/profile and used to seed the JWT-decoded session. */
export const DEMO_ADMIN_USER: UserResponse = {
  id: 9101,
  firstName: 'Jordan',
  lastName: 'Lee',
  email: 'demo-admin@app-doctor.io',
  mobile: '+1 (555) 010-0100',
  isActive: true,
  isEmailVerified: true,
  isMobileVerified: true,
  lastLogin: NOW_ISO,
  createdAt: JOINED_ISO,
  updatedAt: NOW_ISO,
  roles: [
    {
      id: 1,
      name: 'CUSTOMER_ADMIN',
      description: 'Organization Administrator',
      isActive: true,
      permissions: []
    }
  ],
  company: {
    id: 501,
    name: 'Acme Mobile Co.',
    location: 'Austin, TX',
    isActive: true,
    dataSharingOptIn: true,
    industry: {
      id: 4,
      name: 'Technology'
    },
    createdAt: JOINED_ISO,
    updatedAt: NOW_ISO
  },
  customerProfile: {
    id: DEMO_CUSTOMER_PROFILE_ID,
    organizationName: 'Acme Mobile Co.',
    industry: 'Technology',
    country: 'United States',
    dataSharingOptIn: true
  },
  subscription: {
    id: 7001,
    status: 'ACTIVE',
    startDate: JOINED_ISO,
    endDate: new Date(Date.now() + 145 * 24 * 60 * 60 * 1000).toISOString(),
    nextBillingDate: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toISOString(),
    autoRenewal: true,
    originalAmount: 79,
    amountPaid: 79,
    paymentMethod: 'card',
    createdAt: JOINED_ISO,
    updatedAt: NOW_ISO,
    plan: {
      id: 2,
      name: 'Pro',
      description: 'For growing teams tracking multiple apps',
      duration: 'MONTHLY',
      price: 79,
      maxApps: 10,
      maxReviewsPerMonth: 5000,
      sentimentAnalysisEnabled: true,
      firebaseIntegrationEnabled: true,
      isActive: true,
      createdAt: JOINED_ISO,
      updatedAt: NOW_ISO
    }
  }
};

/** Other members of the demo organization, seeded into DemoStore.teamMembers. */
export const DEMO_TEAM_MEMBERS: UserResponse[] = [
  DEMO_ADMIN_USER,
  {
    id: 9102,
    firstName: 'Priya',
    lastName: 'Nair',
    email: 'priya.nair@acmemobile.io',
    mobile: '+1 (555) 010-0102',
    isActive: true,
    isEmailVerified: true,
    isMobileVerified: false,
    lastLogin: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    createdAt: new Date(Date.now() - 150 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: NOW_ISO,
    roles: [{ id: 2, name: 'CUSTOMER_USER', description: 'Team Member', isActive: true, permissions: [] }],
    customerProfile: {
      id: DEMO_CUSTOMER_PROFILE_ID,
      organizationName: 'Acme Mobile Co.',
      industry: 'Technology',
      country: 'United States',
      dataSharingOptIn: true
    }
  },
  {
    id: 9103,
    firstName: 'Marcus',
    lastName: 'Chen',
    email: 'marcus.chen@acmemobile.io',
    mobile: '+1 (555) 010-0103',
    isActive: true,
    isEmailVerified: true,
    isMobileVerified: true,
    lastLogin: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000).toISOString(),
    createdAt: new Date(Date.now() - 95 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: NOW_ISO,
    roles: [{ id: 2, name: 'CUSTOMER_USER', description: 'Team Member', isActive: true, permissions: [] }],
    customerProfile: {
      id: DEMO_CUSTOMER_PROFILE_ID,
      organizationName: 'Acme Mobile Co.',
      industry: 'Technology',
      country: 'United States',
      dataSharingOptIn: true
    }
  }
];
